import { isNotEmpty } from '@rehaje/shared'

import { SchemaDefinition } from '../../models/SchemaDefinition'

import type { SchemaReferenceSpecific, TypedSchema } from '../../types'

export class SchemaReferenceDefinition extends SchemaDefinition {
  override defaultsMerge(
    value: any,
    schema: SchemaReferenceSpecific,
    initialize: boolean
  ) {
    const ref = this.getSchemaById(schema.ref)
    return super.defaultsMerge(value, ref, initialize)
  }

  override getIn(
    schema: SchemaReferenceSpecific,
    path: PropertyKey[]
  ): TypedSchema {
    const ref = this.getSchemaById(schema.ref)
    if (ref) return super.getIn(ref, path)
    return schema
  }

  override infer(
    target: any,
    schema: SchemaReferenceSpecific,
    path: PropertyKey[]
  ): TypedSchema {
    const ref = this.getSchemaById(schema.ref)
    return this.__r_hoistMetadata(super.infer(target, ref, path), schema)
  }

  override inferOnlySchema(
    schema: SchemaReferenceSpecific,
    path: PropertyKey[]
  ): TypedSchema {
    const ref = this.getSchemaById(schema.ref)
    return super.infer(undefined, ref, path)
  }

  override inferTypeScript(
    schema: SchemaReferenceSpecific,
    path: PropertyKey[]
  ): string {
    return super.inferTypeScript(this.infer(schema.value, schema, path), path)
  }

  override prune(
    target: any,
    schema: SchemaReferenceSpecific,
    path?: PropertyKey[],
    parent?: any
  ) {
    const ref = this.getSchemaById(schema.ref)
    return super.prune(target, ref, path, parent)
  }

  override transform(
    target: any,
    schema: SchemaReferenceSpecific,
    path: PropertyKey[]
  ) {
    const ref = this.getSchemaById(schema.ref)
    return super.transform(target, ref, path)
  }

  override validate(target: any, schema: SchemaReferenceSpecific) {
    if (this.validateMetadata(target, schema, 'string', isNotEmpty)) return
    this.catch(() => {
      super.validate(target, this.getSchemaById(schema.ref))
    }).forEach((error) => {
      this.raise(error)
    })
  }
}
